import React from 'react';
import './About.css';

const About = () => {
  const acknowledgements = [
    { name: "Dr. Sanjay Mahajani", role: "Professor-in-Charge, GESH IITB" },
    { name: "Dr. Archak Mittal", role: "Faculty Advisor, RePedal Initiative" },
    { name: "Dr. Wazeem Nishad", role: "Chief Operating Officer, GESH IITB" },
    { name: "Mr. Prabodh Gadkari", role: "Program Manager, GESH IITB" },
    { name: "Mr. Sreejesh Warrier", role: "Project Technical Assistant, GESH IITB" },
    { name: "Mr. Ritesh Kumar", role: "Student Lead, RePedal Initiative" },
    { name: "Ms. Riddhi Agrawal", role: "GESH Fellow, RePedal Initiative" },
    { name: "Ms. Sukriti Sanawar", role: "GESH Fellow, RePedal Initiative" }
  ];

  return (
    <section className="about-section">
      <div className="about-container">
        <div className="about-block">
          <h2>About RePedal Initiative</h2>
          <p>
            RePedal is an initiative under the Research Hub for Green Energy and Sustainability (GESH), IIT Bombay, to build a circular and sustainable bicycle ecosystem within the IIT Bombay campus. With hundreds of abandoned cycles annually, and a significant student interest in second-hand bicycles, this project aims to refurbish and redistribute bicycles to promote cycling as a safe, affordable, and eco-friendly transport mode.
          </p>
          <p>
            A huge number of abandoned cycles that take up space, increase waste and are not handled well. There is a disconnect between supply and demand, with every batch of new students requiring affordable cycles. Auctions are not frequent enough, about 30% of disposed cycles are in decent conditions currently, and 60% student population is willing to use second-hand. Even after the auction, many cycles remain unsold because of their conditions and therefore, they end up in scrap; It's a clear case of underutilization of a valuable resource. 
          </p>
          <p>
            We want to establish a system where we will be refurbishing abandoned cycles and providing these to students at a pocket-friendly cost. Also, Students don’t want to take up the responsibility of the cycle for long. For example, during semester breaks, students find it very hard to maintain their cycle, and when they come back, their cycle already gets into a very deteriorated condition. Therefore, We will be operating on both sale and rental (renting for a semester) model. 
          </p>
        </div>

        <div className="about-block">
          <h2>About GESH</h2>
          <p>
            The IIT Bombay Research Hub for Green Energy and Sustainability is a pioneering centre dedicated to addressing the global climate crisis by facilitating technological, management & policy solutions through research in green energy and sustainability domains. We envision bridging the gap between academic research and real-world application while fostering education and entrepreneurship in these critical fields. We aim to nurture the next generation of green energy and sustainability leaders to tackle complex environmental challenges from multiple angles, promoting creativity and innovation. GESH IITB will be the first point of contact for green energy and sustainability research, education and other services at IITB.
          </p>
          <p>
            The hub was established in 2024 by an unprecedented 18.6 million USD donation from a US-based alumnus, and our hub represents a significant leap forward in environmental stewardship and sustainable solutions.
          </p>
        </div>

        <div className="about-block">
          <h2>Acknowledgements</h2>
          <p>We extend our heartfelt gratitude to the following individuals who have made RePedal Initiative possible:</p>
          <div className="acknowledgements-grid">
            {acknowledgements.map((person, index) => (
              <div key={index} className="acknowledgement-card">
                <h4>{person.name}</h4>
                <p>{person.role}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;